/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes, { arrayOf, shape } from 'prop-types';
import { Heading, Paragraph } from 'components/common';
import {
  sortArticlesByDate,
  filterArticlesByYear,
} from './PressPageUtility';
import { formatDate } from '../../helpers/DateFormatUtil';
import './MediaCoverageContent.scss';
import NoPressContent from './NoPressContent';

const MediaCoverageContent = ({ content, yearFilter, nothingtToShow }) => {
  const filterArticles = filterArticlesByYear(content, yearFilter);
  const sortArticles = sortArticlesByDate(filterArticles);

  return (
    <div className="media-coverage-content">
      <ul className="article-list">
        { sortArticles.length === 0 ? <NoPressContent text={nothingtToShow} />
          : sortArticles
            .map((val, idx) => (
              // eslint-disable-next-line
              <li key={idx}>
                <div className="date-wrapper">
                  <Paragraph>
                    {formatDate(val.date)}
                    |
                    { val.media }
                  </Paragraph>
                </div>
                { (typeof val.link === 'object') ? (
                  val.link.map((l, i) => (
                    <div>
                      <a
                        href={l}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="article-title"
                      >
                        <Heading primary as="h3">{val.title[i]}</Heading>
                      </a>
                    </div>
                  ))
                ) : (
                  <a
                    href={val.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="article-title"
                  >
                    <Heading primary as="h3">{val.title}</Heading>
                  </a>
                )
                }
              </li>
            ))
        }
      </ul>
    </div>
  );
};

MediaCoverageContent.propTypes = {
  content: arrayOf(shape({
    link: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
  })),
  yearFilter: PropTypes.string,
  nothingtToShow: PropTypes.string,
};

MediaCoverageContent.defaultProps = {
  content: null,
  yearFilter: null,
  nothingtToShow: null,
};

export default MediaCoverageContent;
